import { join } from 'lodash';

export const joinPath = (...args) => join(args, ':');


// WEBPACK FOOTER //
// ./src/util/storageHelpers.js